import React from 'react';
import { Table } from 'react-bootstrap';

const SummaryComponent = ({ ballByBall }) => {
  return (
    <div id="summary-commentary">
      <div className="row">
        <div className="commentary-block">
          <Table striped bordered hover>
            <tbody>
              {ballByBall.summaryCoverage.map((summary, index) => (
                <tr key={index}>
                  {summary.type === "oversummary" ? (
                    <td colSpan="2">
                      <table className={`end-of-over-player-stat ${summary.powerplay ? 'powerplay' : ''}`}>
                        <tbody>
                          <tr>
                            <td colSpan="4">
                              <span className="bold">
                                {summary.endofmatch
                                  ? "End of Match"
                                  : `End of Over ${summary.summary.ov}${
                                      summary.powerplay ? " (Powerplay)" : ""
                                    }`}
                              </span>{" "}
                              ({summary.summary.r} runs, {summary.summary.w} wickets){" "}
                              <span className="bold">
                                {summary.summary.tm} {summary.summary.sc}
                              </span>
                            </td>
                          </tr>
                          {summary.summary.eq && (
                            <tr>
                              <td colSpan="4">{summary.summary.eq}</td>
                            </tr>
                          )}
                          <tr>
                            <td className="over-stat-name">{summary.summary.on.name}</td>
                            <td className="over-stat-score">{summary.summary.on.stat}</td>
                            <td className="over-stat-name">{summary.summary.bowl.name}</td>
                            <td className="over-stat-score">{summary.summary.bowl.stat}</td>
                          </tr>
                          <tr>
                            <td className="over-stat-name">{summary.summary.off.name}</td>
                            <td className="over-stat-score">{summary.summary.off.stat}</td>
                            <td className="over-stat-name"></td>
                            <td className="over-stat-score"></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  ) : (
                    <>
                      {summary.type === "comment" ? (
                        <td colSpan="2" className={`ball-commentary ${summary.powerplay ? 'powerplay' : ''}`}>
                          {summary.c}
                        </td>
                      ) : (
                        <>
                          <td className="commentary-over">
                            {summary.o}
                            <div>
                              <span className={`runs runs-${summary.type}`}>{summary.r}</span>
                            </div>
                          </td>
                          <td className={`ball-commentary ${summary.powerplay ? 'powerplay' : ''}`}>
                            {summary.c}
                          </td>
                        </>
                      )}
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="commentator-scorer">
          <p className="cs-commentator">
            <strong>Scorer and Commentator </strong> : {ballByBall.scorer}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SummaryComponent;
